export default "__VITE_ASSET__63AjoFso__"